import { createRequestHelper } from '@utils/swr'
import { type CampaignBannersRequest } from '../types/apiRequest'
import { type CampaignBannersResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['campaignBanners'], CampaignBannersResponse, CampaignBannersRequest>({
  client: 'fortune',
  key: params => params?.campaign_code ? `/campaigns/${params.campaign_code}/banners` : null,
})

export const useApiCampaignBanners = useRequest
